import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './invoice.reducer';

export const InvoiceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const invoiceEntity = useAppSelector(state => state.invoice.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="invoiceDetailsHeading">
          <Translate contentKey="crawlerBackendApp.invoice.detail.title">Invoice</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.id}</dd>
          <dt>
            <span id="sumFixedMonthlyPrice">
              <Translate contentKey="crawlerBackendApp.invoice.sumFixedMonthlyPrice">Sum Fixed Monthly Price</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.sumFixedMonthlyPrice}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="crawlerBackendApp.invoice.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {invoiceEntity.startDate ? (
              <TextFormat value={invoiceEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="crawlerBackendApp.invoice.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {invoiceEntity.endDate ? (
              <TextFormat value={invoiceEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="invoiceStatus">
              <Translate contentKey="crawlerBackendApp.invoice.invoiceStatus">Invoice Status</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.invoiceStatus}</dd>
          <dt>
            <span id="invoiceType">
              <Translate contentKey="crawlerBackendApp.invoice.invoiceType">Invoice Type</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.invoiceType}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.invoice.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {invoiceEntity.createdTimestamp ? (
              <TextFormat value={invoiceEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="invoiceNumber">
              <Translate contentKey="crawlerBackendApp.invoice.invoiceNumber">Invoice Number</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.invoiceNumber}</dd>
          <dt>
            <span id="relation">
              <Translate contentKey="crawlerBackendApp.invoice.relation">Relation</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.relation}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.invoice.description">Description</Translate>
            </span>
          </dt>
          <dd>{invoiceEntity.description}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.invoice.agreement">Agreement</Translate>
          </dt>
          <dd>{invoiceEntity.agreement ? invoiceEntity.agreement.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/invoice" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/invoice/${invoiceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InvoiceDetail;
